import { type AutomationEdgeType, type AutomationNodeType } from '@repo/utils';

export const getAutomationTree = (withSuccessExecutionCounts = false) => `
query AutomationTree($automationId: ID!) {
  automationTree(automationId: $automationId) {
    id
    nodeType
    nodeSubType
    status
    executionOrder
    description
    additionalOptions
    ${withSuccessExecutionCounts ? 'successExecutionCounts' : ''}
    sourceEdges {
      id
      targetNodeId
      status
    }
  }
}
`;

export type GetAutomationTreeResponse = {
  automationTree: (Omit<AutomationNodeType,
  'isCustom' | 'name' | 'sourceEdges'
  > & {
    sourceEdges: Pick<AutomationEdgeType, 'id' | 'targetNodeId' | 'status'>[];
  })[];
};
